import { __awaiter } from "tslib";
import { initReactI18next } from 'react-i18next';
import { abTranslate } from './ab-translate';
export function withI18n(options, packages, enJson, langResolver) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!options) {
            return packages;
        }
        yield initI18n(options.i18next, options.locale, enJson, langResolver);
        return packages;
    });
}
function initI18n(i18next, locale, enJson, langResolver) {
    return __awaiter(this, void 0, void 0, function* () {
        const abTranslatedJson = abTranslate(window.responsiveEditorModel.experiments, enJson);
        if (!i18next.isInitialized) {
            yield i18next.use(initReactI18next).init({
                debug: window.responsiveEditorModel.environment.isDebug &&
                    !window.responsiveEditorModel.environment.isAutomation,
                lng: locale,
                fallbackLng: 'en',
                keySeparator: '$',
                resources: {
                    en: {
                        translation: abTranslatedJson,
                    },
                },
            });
        }
        else {
            i18next.addResources('en', 'translation', abTranslatedJson);
        }
        if (locale !== 'en') {
            try {
                const res = yield langResolver(locale);
                i18next.addResources(locale, 'translation', abTranslate(window.responsiveEditorModel.experiments, res.default));
            }
            catch (e) {
                console.log(`Failed to load language chunk for: ${locale}`, e);
            }
        }
        return i18next;
    });
}
//# sourceMappingURL=i18n.js.map